import React from 'react';
import Rutas from './components/Rutas';
import { Box } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './elements/Context/AuthContext';

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Box>
          <AuthProvider>
            <Routes>
              <Route path='/*' element={<Rutas/>}/>
            </Routes>
          </AuthProvider>
        </Box>      
      </BrowserRouter>
    </>
  );
}

export default App;
